export default __webpack_public_path__ + "assets/25a58c1b44b3b77d962d27d7733bc9da.jpg";